/*******************************************************
Toggle Sub Navigation
Shows or hides the navigation menus that appear below links in the section nav.
********************************************************/

import closeDropdownMenu from './close-dropdown';
import calculateDropdownPosition from './calculate-dropdown-pos';

export default function toggleSubNav(e) {

    // Get the navigation item that is being selected/hovered over
    const $selectedItem = $(e.currentTarget);

    // If this isn't a dropdown (just a single link), then exit out
    if ($selectedItem.find('.s-nav__link').length > 0) { return; }

    // Prevents the mouse event from occurring if the touch event is triggered (except for the side nav trigger element)
    if (e.type === 'touchstart' && !$selectedItem.hasClass('open-side-nav')) { e.preventDefault(); }

    // Check to see if a menu is currently open
    const menuIsOpen = $selectedItem.hasClass('open');

    // Find the sub navgations
    let $selectedSubNav = $(`.s-sub-nav__group[data-item="${$selectedItem.data('name')}"]`);
    if ($selectedSubNav.length === 0) {
        $selectedSubNav = $(`.section-sub-nav__group[data-item="${$selectedItem.data('name')}"]`);
    }

    // Exit out if there is no sub navigation to display
    if ($selectedSubNav.length === 0) { return; }

    // Close all sub navigation menus to have a clean slate
    closeDropdownMenu();

    // If a menu was already open, then we know the user is trying to close it (which we've done above)
    if (menuIsOpen && e.type === 'touchstart') { return; }

    // Add the 'open' class to the selected item
    $selectedItem.addClass('open');

    // Make the selected sub nav visible
    $selectedSubNav.removeClass('hide');

    // Position the sub nav below the selected item
    $selectedSubNav.css('left', calculateDropdownPosition($selectedItem));
}
